import { useInitializePostHog } from './useInitializePostHog';
import { useInitializeWallet } from './useInitializeWallet';

export const useInitializeApp = () => {
  useInitializeWallet();
  useInitializePostHog();
};
